module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_dark.0a072b70.svg";